// extracted by mini-css-extract-plugin
export default {"DepartmentNavWrapper":"departmentNav_DepartmentNavWrapper__jGTE9","DepartmentNav":"departmentNav_DepartmentNav__vPm+f","Button":"departmentNav_Button__9KLNW"};